import React, { useMemo } from "react";
import { message, Select } from "antd";
import _ from "lodash";
import { MinusCircleFilled, PlusSquareFilled } from "@ant-design/icons";
import Card from "./card";
import Card2 from "./card2";
import CompletedOrders from "../../completedOrders";

const ContentSection = (props) => {
  const {
    wrapperRef,
    zooming,
    setZooming,
    currentFilter,
    expoData,
    setCurrentFilter,
    onSendOrder,
    selectedMenuItemId,
    handleUpdateCartItem,
    setShowCompleted,
    showCompleted
  } = props;

  const zoomIn = () => {
    let currentZoom = parseInt(wrapperRef.current.style.zoom.replace("%", ""));
    if (currentZoom < 130) {
      wrapperRef.current.style.zoom = currentZoom + 5 + "%";
      setZooming(currentZoom + 5 + "%");
    } else {
      message.warning("Maximum zoom limit reached");
    }
  };
  const zoomOut = () => {
    let currentZoom = parseInt(wrapperRef.current.style.zoom.replace("%", ""));
    if (currentZoom > 70) {
      wrapperRef.current.style.zoom = currentZoom - 5 + "%";
      setZooming(currentZoom - 5 + "%");
    } else {
      message.warning("Minimum zoom limit reached");
    }
  };

  const ordersToShow =  useMemo(() => {
    if (currentFilter) {
      return expoData.map((items) => {
        return items.filter(( cart_item ) => cart_item.kitchen_priority === currentFilter);
      });
    };
    return expoData;
  }, [expoData, currentFilter]);

  return (
    <div>
      <div className="title_header">
        <h2 className="title">Expo Screen</h2>
        <div>
          <span className="label">Zoom: </span>
          <MinusCircleFilled onClick={zoomOut} />
          <span className="zoomval">{zooming}</span>
          <PlusSquareFilled onClick={zoomIn} />
        </div>
      </div>
      <div className="filter_head">
        <div className="filter_sec">
          <div
            className={currentFilter ? "filter_box" : "filter_box border"}
            onClick={() => {
              setCurrentFilter("");
            }}
          >
            All Orders
          </div>
          <div
            className={
              currentFilter === "HIGH"
                ? "filter_box high border"
                : "filter_box high"
            }
            onClick={() => {
              setCurrentFilter("HIGH");
            }}
          >
            Hign Priority
          </div>
          <div
            className={
              currentFilter === "MEDIUM"
                ? "filter_box medium border"
                : "filter_box medium"
            }
            onClick={() => {
              setCurrentFilter("MEDIUM");
            }}
          >
            Medium Priority
          </div>
          <div
            className={
              currentFilter === "LOW"
                ? "filter_box low border"
                : "filter_box low"
            }
            onClick={() => {
              setCurrentFilter("LOW");
            }}
          >
            Low Priority
          </div>
          <div className="border_l" />
          <div className={showCompleted ? "filter_box complete border" : "filter_box complete" }
            onClick={()=>{setShowCompleted(!showCompleted)}}
            >Completed Orders</div>
        </div>
      </div>
      <div className="yetsend_sec">
        <div className="sub_title">Yet to Send</div>
        <div className="card_wrap">
        {ordersToShow.map((orders, i) => (
          <Card
            key={i}
            cardData={orders.filter(( cart_item ) => !cart_item.is_sent_to_kitchen && cart_item.kitchen_priority !== 'READY')}
            // expoGroup={orders.priority}
            onSendOrder={onSendOrder}
            selectedMenuItemId={selectedMenuItemId}
          />
        ))}
        </div>
      </div>
      <div className="yetsend_sec">
        <div className="sub_title">Ready orders</div>
        <div className="card_wrap">
          {ordersToShow.map((orders, i) => {
            return <Card2 key={i} handleUpdateCartItem={handleUpdateCartItem} cardData={orders.filter((cart_item ) => cart_item.kitchen_priority === 'READY')} />;
          })}
        </div>
      </div>
      {showCompleted && 
      <div className="yetsend_sec">
        <div className="sub_title">Completed orders</div>
        <div className="card_wrap">
          <CompletedOrders />
        </div>
      </div>}
    </div>
  );
};
export default ContentSection;
